import './SupportBanner.css';

const SUPPORT_URL = 'https://paypal.me/EmulousStudio';

export default function SupportBanner({ compact = false, className = '' }) {
  return (
    <div className={`support-banner ${compact ? 'support-banner--compact' : ''} ${className}`.trim()}>
      <a
        href={SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="support-banner__link"
      >
        <span className="support-banner__icon" aria-hidden="true">♡</span>
        <span>Support This Project</span>
      </a>
    </div>
  );
}
